import {
    ShoppingListProductModel,
    ShoppingListProductPayload,
} from '../../../../types/ShoppingListProduct';
import { DBWriterLoggerFunction } from '../../../../types/logger';

export const prepareUpdateShoppingListProduct = ({
    shoppingListProductElement,
    payload,
    organisationID,
}: {
    shoppingListProductElement: ShoppingListProductModel;
    payload: ShoppingListProductPayload;
    organisationID: string;
}) =>
    shoppingListProductElement.prepareUpdate((product) => {
        product.organisationId =
            shoppingListProductElement.organisationId || organisationID;
        product.quantity = payload.quantity;
        product.totalQuantity = payload.totalQuantity;
        product.unitType = payload.unitType;
        product.productSalesUnitId =
            payload.productSalesUnitId || product.productSalesUnitId;
    });

export const logUpdateShoppingListProductAction = ({
    shoppingListProductElement,
    logDBAction,
    tableName,
}: {
    shoppingListProductElement: ShoppingListProductModel;
    logDBAction: DBWriterLoggerFunction;
    tableName: string;
}) => {
    logDBAction({
        message: 'Update shopping list product',
        modelName: tableName,
        payload: shoppingListProductElement,
    });
};
